import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { sortApiNamesByProductLevel } from 'pricing-pages-lib/utils/sortingUtils';
import styled from 'styled-components';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { transformFeatureRecord } from '../../utils/translatedFeatureUtils';
import { FeatureAvailableIcon, FeatureUnavailableIcon } from './SharedComponents';
import TranslatedFeature from './TranslatedFeature';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTooltipSection = styled.div.withConfig({
  displayName: "FeatureTableCell__StyledTooltipSection",
  componentId: "sc-1yjyzjw-0"
})(["margin-bottom:8px;&:last-child{margin-bottom:0;}"]);
const ShortLimitContent = styled.span.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "FeatureTableCell__ShortLimitContent",
  componentId: "sc-1yjyzjw-1"
})([""]);
const FeatureTableCell = ({
  feature,
  apiName,
  showTooltip = true,
  onlyShowCurrentLongLimit = false
}) => {
  const getProductFeatureLongLimit = () => {
    const sections = [];
    if (!Object.keys(feature.longLimits).length) {
      return null;
    }
    const shouldShowTooltip = onlyShowCurrentLongLimit ? !!feature.longLimits[apiName] : !!Object.keys(feature.longLimits).find(innerApiName => {
      return !!feature.longLimits[innerApiName];
    });
    if (shouldShowTooltip) {
      const sortedApiNames = onlyShowCurrentLongLimit ? [apiName] : sortApiNamesByProductLevel(Object.keys(feature.longLimits));
      sortedApiNames.forEach(innerApiName => {
        const level = getProductLevelFromApiNameString(innerApiName);
        sections.push({
          key: `${innerApiName}-${feature.featureId}`,
          value: /*#__PURE__*/_jsx(TranslatedFeature, {
            translated: transformFeatureRecord({
              feature,
              apiName: innerApiName
            }),
            productLevel: getProductLevelFromApiNameString(innerApiName),
            attribute: "longLimit"
          }),
          label: `pricing-pages.tooltips.labels.${level}`
        });
      });
      const formattedSections = [];
      sections.forEach(({
        key,
        value,
        label
      }) => {
        if (label) {
          formattedSections.push( /*#__PURE__*/_jsxs(StyledTooltipSection, {
            id: key,
            children: [/*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: label
              })
            }), /*#__PURE__*/_jsx("span", {
              children: value
            })]
          }, key));
        }
      });
      return formattedSections;
    }
    return null;
  };
  const getTableCellContent = () => {
    const hasFeature = feature.shouldUseDefaultLimits[apiName] || feature.shortLimits[apiName];
    if (!hasFeature) return /*#__PURE__*/_jsx(FeatureUnavailableIcon, {});
    const longLimitContent = getProductFeatureLongLimit();
    const hasTooltip = showTooltip && longLimitContent;
    const shortLimitContent = feature.shortLimits[apiName] ? /*#__PURE__*/_jsx(ShortLimitContent, {
      style: hasTooltip ? {
        cursor: 'help'
      } : {},
      children: /*#__PURE__*/_jsx(TranslatedFeature, {
        translated: transformFeatureRecord({
          feature,
          apiName
        }),
        productLevel: getProductLevelFromApiNameString(apiName),
        attribute: "shortLimit"
      })
    }) : /*#__PURE__*/_jsx(FeatureAvailableIcon, {});
    return hasTooltip ? /*#__PURE__*/_jsx(UITooltip, {
      use: "longform",
      placement: "left",
      disabled: !showTooltip,
      title: longLimitContent,
      children: shortLimitContent
    }) : shortLimitContent;
  };
  return /*#__PURE__*/_jsx("td", {
    className: "p-x-1",
    children: getTableCellContent()
  });
};
export default FeatureTableCell;